const splashImgs = document.querySelectorAll('.js-splash-img')

function animateBgImage() {
    const animatingImageTl = gsap.timeline({
        paused: true,
        repeat: -1,
        yoyo: true
    });

    splashImgs.forEach((img) => {
        animatingImageTl.to(img, 20, {
            rotation: "10",
            scale: 1.2,
            ease: "linear"
        });
    })

    animatingImageTl.pause();
    animatingImageTl.restart();
}


animateBgImage();